import { Action } from '../../definitions/types';
import * as actions from '../actions/actions-consts';
import { ErrorPayload } from '../actions/errors';

export const GENERAL_SERVER_ERROR = 'signup-flow.signup.errors.blob_api';
export const INVALID_USER_ID_TOKEN = 'signup-flow.signup.errors.invalid_token';
export const INVALID_USER_ACCOUNT_ID_TOKEN = 'signup-flow.tos.errors.invalid_user_account_id_token'; // TODO clean-up GRW-1410 GRW-1416

export default function error(
  state: string = null,
  action: Action<any> // tslint:disable-line no-any
): string {
  switch (action.type) {
    case actions.GENERAL_REQUEST_FAILED:
      return (action.payload as ErrorPayload).error;
    case actions.INVALID_USER_ID_TOKEN:
    case actions.TOS_ACCEPTANCE_FAILED:
      return (action.payload as ErrorPayload).error;
    case actions.UNSET_GLOBAL_ERROR:
    case actions.SIGNUP_SUBMIT_REQUESTED:
    case actions.CHANGE_PASSWORD_VALUE:
    case actions.CHANGE_EMAIL_VALUE:
    case actions.TLD_VALUE_CHANGED:
    case actions.DOMAIN_FIELD_VALUE_CHANGED:
    case actions.USERNAME_VALUE_CHANGED:
      return null;
    default:
      return state;
  }
}
